// Ren merge-logikk for Google Places-autofyll i AddSpotModal.
// Regel: fyll KUN felt som er tomme fra før — brukerens egne verdier overstyres
// aldri. Returnerer hvilke felt som ble fylt, slik at UI kan merke dem «AI-forslag».
// Holdt pure (ingen React) for å være enhetstestbar.

export interface CampsiteEnrichmentData {
  website?: string | null;
  phone?: string | null;
  opening_hours?: string | null;
  description?: string | null;
  rating?: number | null;
  ratingCount?: number | null;
  googleMapsUri?: string | null;
  placeId?: string | null;
}

export interface CampsiteCurrentValues {
  phone: string;
  opening_hours: string;
  description: string;
  website: string;
}

export type CampsiteField = 'phone' | 'opening_hours' | 'description' | 'website';

export interface CampsiteMergeResult {
  updates: Partial<Record<CampsiteField, string>>;
  filled: CampsiteField[];
}

const FIELDS: CampsiteField[] = ['phone', 'opening_hours', 'description', 'website'];

/**
 * Slår sammen Places-berikelse med brukerens nåværende felt. Et felt fylles bare
 * hvis (a) berikelsen har en ikke-tom verdi, og (b) brukerens felt er tomt.
 */
export function mergeCampsiteEnrichment(
  current: CampsiteCurrentValues,
  data: CampsiteEnrichmentData | null | undefined,
): CampsiteMergeResult {
  const updates: Partial<Record<CampsiteField, string>> = {};
  const filled: CampsiteField[] = [];
  if (!data) return { updates, filled };

  for (const field of FIELDS) {
    const incoming = data[field];
    const currentVal = (current[field] || '').trim();
    if (incoming && String(incoming).trim() && !currentVal) {
      updates[field] = String(incoming);
      filled.push(field);
    }
  }
  return { updates, filled };
}
